import React, {ChangeEvent, useState} from 'react';
import {I18n} from 'react-redux-i18n';

import {FormControlLabel, withStyles, WithStyles} from '@material-ui/core';

import Checkbox from '@material-ui/core/Checkbox';

import QRCode from 'react-qr-code';
import GooglePlayIcon from './img/GooglePlaySVG';
import AppleStoreIcon from './img/AppleStoreSVG';

import style from './style';
import RenderDivOrEmpty from '../RenderDivOrEmpty/RenderDivOrEmpty';

const GOOGLE_PLAY_LINK = 'https://play.google.com/store/apps/details?id=com.azure.authenticator';
const APPLE_STORE_LINK = 'https://apps.apple.com/en/app/microsoft-authenticator/id983156458';

type DownloadTOTPAppProps = WithStyles<typeof style> & {
  isAppInstalled: boolean;
  // eslint-disable-next-line no-unused-vars
  setIsAppInstalled: (val: boolean) => void;
};

function DownloadTOTPApp({
  classes,
  isAppInstalled,
  setIsAppInstalled,
}: DownloadTOTPAppProps) {
  const [isShowQr, setIsShowQr] = useState(false);

  return (
    <>
      <p>
        {I18n.t('totp.setup.install.textFirstPart')}
        <button
          className={classes.installQRsContainer__showButton_link}
          type="button"
          onClick={() => setIsShowQr(!isShowQr)}
        >
          {I18n.t('totp.setup.install.microsoftAppName')}
        </button>
        {I18n.t('totp.setup.install.textSecondsPart')}
      </p>
      <RenderDivOrEmpty
        isShow={isShowQr}
        className={classes.installQRsContainer}
      >
        <div className={classes.installQRsContainer__column}>
          <div className={classes.installQRsContainer__qr}>
            <QRCode
              style={{height: 'auto', maxWidth: '100%', width: '100%'}}
              value={GOOGLE_PLAY_LINK}
            />
          </div>
          <GooglePlayIcon />
        </div>
        <div className={classes.installQRsContainer__column}>
          <div className={classes.installQRsContainer__qr}>
            <QRCode
              style={{height: 'auto', maxWidth: '100%', width: '100%'}}
              value={APPLE_STORE_LINK}
            />
          </div>
          <AppleStoreIcon />
        </div>
      </RenderDivOrEmpty>
      <FormControlLabel
        control={(
          <Checkbox
            checked={isAppInstalled}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setIsAppInstalled(e.target.checked)}
          />
        )}
        classes={{
          label: classes.checkbox__label,
        }}
        label={I18n.t('totp.setup.install.appInstalledCheckbox')}
      />
    </>
  );
}

export default withStyles(style)(DownloadTOTPApp);
